<template>
  <div class="campsite-notices">
    <ul v-if="warnings.length">
      <li v-for="(warning, index) in warnings" :key="index" class="warning">
        <img
          loading="lazy"
          src="@/assets/images/exclamation-mark.svg"
          width="18"
          height="18"
          alt=""
        />{{ warning }}
      </li>
    </ul>
    <ul v-if="campsiteNotices && campsiteNotices.length">
      <li v-for="(notice, index) in filteredCampsiteNotices" :key="index">
        <img
          loading="lazy"
          src="@/assets/images/exclamation-mark-blue.svg"
          width="18"
          height="18"
          alt=""
        />
        <div class="preserve-linebreaks" v-thtml="notice.text" />
      </li>
    </ul>
    <template v-if="notices && notices.length">
      <ul>
        <li>
          <img
            loading="lazy"
            src="@/assets/images/exclamation-mark-blue.svg"
            width="18"
            height="18"
            alt=""
          />
          <div
            v-thtml="notices"
            class="preserve-linebreaks prerendered"
            data-g-translate="notices"
          />
        </li>
      </ul>

      <lazy-google-translate-button
        v-if="noticesNeedsTranslation"
        format="text"
        query-selector-value="notices"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { CampsiteNotices } from '../../apps/campsite-details/types'

@Component
class CampsiteNoticesComponent extends Vue {
  @Prop({ default: () => [] })
  warnings: string[]

  @Prop({ required: true })
  notices: string

  @Prop({ default: false })
  noticesNeedsTranslation: boolean

  @Prop()
  campsiteNotices: CampsiteNotices[]

  get filteredCampsiteNotices() {
    return this.campsiteNotices?.filter(
      (notice) => !notice.isCovid && !this.warnings.includes(notice.text),
    )
  }
}

export default toNative(CampsiteNoticesComponent)
</script>

<style scoped>
li {
  margin: 0 0 1em;
  padding: 0 0 0 1.6em;
  position: relative;
}

li img {
  display: inline-block;
  position: absolute;
  left: 0;
  width: 1.2em;
  height: 1.2em;
}

.warning {
  font-weight: bold;
}

.campsite-notices :deep(.google-translate) {
  margin-left: 1.6em;
}
</style>
